import React from 'react';
import { Coffee, Clock, ArrowRight } from 'lucide-react';
import { LatteButton, LatteSpinner } from '../common';

const HeroSection = ({ 
  displayName, 
  loading, 
  currentSession, 
  onContinueConsulting, 
  onStartNewConsulting 
}) => {
  return (
    <section className="hero-section">
      <div className="hero-container">
        <div className="hero-with-image">
          <div className="hero-content-left">
            <h1 className="hero-title-modern">
              30분 대화 → <span className="gradient-text">커리어 풀세트</span> 완료
            </h1>
            
            <p className="hero-description-modern">
              {displayName && displayName !== '사용자' && (
                <>
                  안녕하세요, <strong>{displayName}</strong>님!<br/>
                </>
              )}
              그냥 편하게 얘기하다 보면, 이력서 · 자소서 · 웹페이지까지 전부 자동 완성!<br/>
              라떼 한 잔 마시는 시간에, 채용 담당자가 혹 할만한 커리어 풀 패키지를 뽑아가세요.
            </p>
            
            <div className="hero-buttons">
              {loading ? (
                <div className="flex-center p-6">
                  <LatteSpinner size="md" text="준비 중..." />
                </div>
              ) : currentSession ? (
                <LatteButton
                  onClick={onContinueConsulting}
                  size="xl"
                  className="btn btn-gradient-modern"
                  data-tour="start-consulting"
                >
                  <Clock className="w-5 h-5" />
                  컨설팅 계속하기
                  <ArrowRight className="w-5 h-5" />
                </LatteButton>
              ) : (
                <LatteButton
                  onClick={onStartNewConsulting}
                  size="xl"
                  className="btn btn-gradient-modern"
                  data-tour="start-consulting"
                >
                  <Coffee className="w-5 h-5" />
                  바로 시작하기
                  <ArrowRight className="w-5 h-5" />
                </LatteButton>
              )}
            </div>
          </div>
          
          <div className="hero-image-container">
            <img 
              src="/images/hero-illustration.png" 
              alt="라떼 한 잔과 함께하는 커리어 컨설팅" 
              className="hero-illustration"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
